import gql from 'graphql-tag';
import { fetchGraphQLQuery } from '@updater-core/lib/graphql';
import { ENVIRONMENT } from '@updater-core/lib/environment';
import { createGateway as createLocalStorageGateway } from '@updater-core/gateways/local-storage';
import { ERROR, TRACK } from '@updater-core/lib/tracker';
import session from '@updater-core/interactors/shell/session';
import tracker from '@updater-core/interactors/shell/tracker';

const prodQuery = gql`
  query isExperimentFeatureEnabled($feature: String!, $attributes: JSON) {
    isExperimentFeatureEnabled(feature: $feature, attributes: $attributes) {
      result
    }
  }
`;
const debugQuery = gql`
  query isExperimentFeatureEnabled($feature: String!, $attributes: JSON) {
    isExperimentFeatureEnabled(feature: $feature, attributes: $attributes) {
      result
      logs
    }
  }
`;

export async function fetchIsExperimentFeatureEnabled({ feature }) {
  const FEATURE_NAME = feature;
  const LOCAL_STORAGE_KEY = `upd_feature.${FEATURE_NAME}`;

  const localStorageGateway = createLocalStorageGateway();

  const localOverride = localStorageGateway.getJSON(LOCAL_STORAGE_KEY);
  if (localOverride && typeof localOverride.enabled === 'boolean') {
    return localOverride.enabled;
  }

  return fetchGraphQLQuery({
    url: `${ENVIRONMENT.endpoints.api.url}/graphql`,
    query: ENVIRONMENT?.debug?.backendOptimizely ? debugQuery : prodQuery,
    headers: {
      ...session.selectors.requestHeaders(session.getState()),
    },
    variables: {
      feature: FEATURE_NAME,
    },
  })
    .then((response) => {
      const result = response?.data?.isExperimentFeatureEnabled?.result;
      const optimizelyLogs = response?.data?.isExperimentFeatureEnabled?.logs;
      tracker.actions.track({
        domain: 'mover',
        object: 'feature',
        verb: TRACK,
        details: {
          [feature]: true,
          ...(optimizelyLogs && { optimizelyLogs }),
        },
      });
      return result;
    })
    .catch(() => {
      tracker.actions.track({
        domain: 'mover',
        object: 'fetch_optimizely_flag',
        verb: ERROR,
      });
      return false;
    });
}
